<template>

    <section id="servicios" class="secciones seccion-blanca">        
          <div class="container">
        <h1>{{internal_name_es}}</h1>
        <span v-html="desc_sub_section_es"></span>
         
        <div class="row">
          
           <div class="col-sm-6 col-md-4 col-lg-3 text-center" v-for="(item, index) in item_list" :key="index">
              <div class="servicios-home animacion">
                <a v-bind:href="item.button_url" target="_blank" class="servicios-home-foto">
                  <img class="imagen-cover" v-bind:src='imgPreUrl+ item.url_image +"x320.jpg"' alt="portada catálogo">
                </a>
                <a v-bind:href="item.button_url" target="_blank" class="servicios-home-texto animacion" style="text-decoration: none;">
                  <h2>{{item.title_item_es}}</h2>
                </a>
              <div class="servicios-home-boton animacion"><a v-bind:href="item.button_url" target="_blank" class="btn-al btn-al-md btn-al-celeste-solid" style="text-decoration: none;">{{item.text_button_es}}</a></div>
              </div>
            </div>
           
         </div>
          
           <router-link to="/catalogos" class="btn-al btn-al-lg btn-al-rojo btn-secciones">Ver todas las publicaciones</router-link>
        </div>
                 
    </section>
</template>


<script>
import axios from "axios";
import {config_settings} from '../../config.js';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  name: "TwoModules",
  data() {
    return {
    imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
    cod_sub_sec: 3,
    nom_sub_sec_es: '',
    nom_sub_sec_en: '',
    internal_name_es: '',
    internal_name_en: '',
    desc_sub_section_es: '',
    desc_sub_section_en: '',
    section: '',
    url_1st_image: 'products/empty-img',
    url_2nd_image: 'products/empty-img',
    url_3rd_image: 'products/empty-img',
    url_4th_image: 'products/empty-img',
    url_5th_image: 'products/empty-img',
    type_1st_image: 'image',
    type_2nd_image: 'image',
    type_3rd_image: 'image',
    type_4th_image: 'image',
    type_5th_image: 'image',
    text1_es: '',
    text1_en: '',
    text2_es: '',
    text2_en: '',
    text3_es: '',
    text3_en: '',
    orientation: '',
    url_es: '',
    url_en: '',
    order_sub_section: '',
    id_position_menu: '',
    url_video: '',
    type: '' ,

    item_list: [],
    crit: 4,
    pages: [],
    final_page: 1,
    current_page: 1
    };
  },

  created() {
    this.obtener_sub_section_data();
    //this.obtener_items();
    this.obtener_items_paginado();
  },

  methods: {

    obtener_sub_section_data(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec)
           .then(response => {
              
              this.nom_sub_sec_es = response.data.nom_sub_sec_es
              this.nom_sub_sec_en = response.data.nom_sub_sec_en
              this.internal_name_es = response.data.internal_name_es
              this.internal_name_en  = response.data.internal_name_en  
              this.desc_sub_section_es = response.data.desc_sub_section_es  
              this.desc_sub_section_en = response.data.desc_sub_section_en  
              this.section = response.data.section  
              this.url_1st_image = response.data.url_1st_image  
              this.url_2nd_image = response.data.url_2nd_image  
              this.url_3rd_image = response.data.url_3rd_image  
              this.url_4th_image = response.data.url_4th_image  
              this.url_5th_image = response.data.url_5th_image  
              this.type_1st_image = response.data.type_1st_image  
              this.type_2nd_image = response.data.type_2nd_image  
              this.type_3rd_image = response.data.type_3rd_image  
              this.type_4th_image = response.data.type_4th_image  
              this.type_5th_image = response.data.type_5th_image  
              this.text1_es = response.data.text1_es  
              this.text1_en = response.data.text1_en 
              this.text2_es = response.data.text2_es  
              this.text2_en = response.data.text2_en  
              this.text3_es = response.data.text3_es  
              this.text3_en = response.data.text3_en  
              this.orientation = response.data.orientation  
              this.url_es = response.data.url_es  
              this.url_en = response.data.url_en  
              this.order_sub_section = response.data.order_sub_section  
              this.id_position_menu = response.data.id_position_menu  
              this.url_video = response.data.url_video 
              this.type = response.data.type 
             
          })
           .catch(error => {
           
      })
    },

    obtener_items_paginado(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec +'/items?cReg=4')
           .then(response => {
             this.crit = 4
             this.item_list = response.data.items;
             this.pages = response.data.visible_pages
             this.final_page = response.data.final_page
             this.current_page = 1
           })
           .catch(error => {
            
            //this.mensaje_error = "No se encontraron resultados de la busqueda filtrada.";
            //this.mensaje = "";
           })
    },

  //manadatory function called from cardTemplate 
}
}
</script>

<style>
.best-products {
  margin-bottom: 10px;
}

#cotizacion {
  padding: 0px;
}
</style>
